import { ActivityTabPanel } from "@/pages/activity/components/ActivityTabPanel";

export function ActivityTab({ id }: { id: string }) {
  return <ActivityTabPanel ownerType="spv_pool" ownerId={id} />;
}
